export default __webpack_public_path__ + "static/media/1.df3e9ebd.jpg";